import React from 'react';
import { useAdministrationOverlay } from '@piwikpro/router-crate';
import Rename from './Rename';
import AddUsers from './AddUsers';
import AddExternalID from './AddExternalID';

/** Details-scoped overlays; hosted here so userGroup is already loaded. */
const UserGroupDetailsOverlay: React.FC = () => {
  const overlay = useAdministrationOverlay();

  if (overlay === '/m/rename') {
    return <Rename />;
  }

  if (overlay === '/o/add-users') {
    return <AddUsers />;
  }

  if (overlay === '/o/add-external-id') {
    return <AddExternalID />;
  }

  return null;
};

export default UserGroupDetailsOverlay;
